import { Breakpoints } from '@volkswagen-onehub/components-core';

export const CustomBreakpoints = {
	MOBILE: 0 as Breakpoints,
	TABLET: 960 as Breakpoints,
	DESKTOP: 1200 as Breakpoints,
	LARGE: 1920 as Breakpoints,
	XLARGE: 2560 as Breakpoints,
} as const;

export type BreakpointKey = keyof typeof CustomBreakpoints;
export type BreakpointValue = (typeof CustomBreakpoints)[BreakpointKey];
